import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import toast from 'src/utils/toast';

interface CopyToClipboardProps {
  text: string;
  ariaLabel?: string;
  onCopy?: () => void;
  children?: React.ReactNode;
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  text,
  ariaLabel,
  onCopy,
  children,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'common.actions',
  });
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success('Copied to clipboard');
      onCopy?.();
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy to clipboard');
    }
  };

  return children ? (
    <div onClick={handleCopy}>{children}</div>
  ) : (
    <IconButton
      aria-label={ariaLabel || t('copyToClipboard')}
      onClick={handleCopy}
    >
      {copied ? <Icon icon={faCheck} /> : <Icon icon={faCopy} />}
    </IconButton>
  );
};
